// extracted by mini-css-extract-plugin
module.exports = {"sky":"interior_sky__3x6LL","corpus":"interior_corpus__1yHo0","upholstery":"interior_upholstery__U5JVS","fronts":"interior_fronts__1vR6d"};